var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_V1_PATH } from "@/06-shared/api/request/config";
import { request } from "@/06-shared/api/request";
const ORDERS_API_PATH = `${API_V1_PATH}/orders`;
export const getOrders = () => request(ORDERS_API_PATH);
export const getOrder = (orderId) => request(`${ORDERS_API_PATH}/${orderId}`);
export const createOrder = (bookId) => __awaiter(void 0, void 0, void 0, function* () {
    return request(ORDERS_API_PATH, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bookId })
    });
});
export const confirmOrder = (orderId) => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${ORDERS_API_PATH}/${orderId}/confirm`, { method: "POST" });
});
export const cancelOrder = (orderId) => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${ORDERS_API_PATH}/${orderId}/cancel`, { method: "POST" });
});
